import React from 'react'
import "./stylesheet/subComponent.css"
// import { Icon } from '@iconify/react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from 'react-router-dom';

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";



// import required modules
import { Pagination } from "swiper";

 const projectDetails=[
  {
    Name:"Market Place App",
    details:"Add product eassily, start selling",
    tag:["React","Node JS","Express js","MongodB",'FetchApi'],
    link:"https:/ecommerce-05.netlify.app/",
    imgLink:"./media/ecom.png"
   },
  {
    Name:"Parking Mangement App",
    details:"Manage the Parking space",
    tag:["HTML","CSS","Javascript","React"],
    link:"https://parkma.netlify.app/",
    imgLink:"./media/parkma.png"
   },
   {
    Name:"Swiggy Clone",
    details:"Manage the Parking space",
    tag:["HTML","CSS","Javascript","React"],
    link:"https://swiggy-clone01.netlify.app/",
    imgLink:"./media/swclone.png"
   },
 {
  Name:"Keep Clone",
  details:"Note app",
  tag:["HTML","CSS","Javascript"],
  link:"https://umangsahu.github.io/keep/index.html",
  imgLink:"./media/keep.png"
 },
 {
  Name:"Jokes Website",
  details:"Random Jokes",
  tag:["HTML","CSS","Javascript","restApi"],
  link:"https://jokessitewithapi.netlify.app/",
  imgLink:"./media/jokesapi.png"
 }
]
export  const Header = () => {
  return (
    <>
    <div className="header">
        <span>Portfolio</span>
        <img src="./media/DP.jpeg" alt="error" />
    </div>
    </>
  )
}


  

  
  const Caraousel = () => {
    return (
      <Swiper
      slidesPerView={3}
      spaceBetween={200}
      loop={true}
      pagination={true} 
      modules={[Pagination]}
      // pagination={{
      //   clickable: true,
      // }}
    
      className="mySwiper">
     

       { projectDetails.map((curelem)=>{
        return(


          <SwiperSlide>
          <a href={curelem.link} target="_blank" className="card">
  <div className="img">
    <img src={curelem.imgLink} alt="err" />
  </div>
  <div className="info">
    <div className="name"> {curelem.Name}</div>
    <div className="specification">{curelem.details}</div>
  <div className="tech">
    {curelem.tag.map((elm)=>{
      return(
 <span className="tag">
 <img src="./media/Subtract.svg" alt="" /> 
 <span className="techName">{elm}</span>
</span>)
    })}


  </div>
  </div>
</a>
</SwiperSlide>

        )
       })}

    </Swiper>
    )
  }
  

export  const Intro = () => {
    return (
      <><div className="intro">
        <div className="bg">
    
    <Link className='myName' id="myName"to="/about"> Umang Sahu</Link>
    <small className='expertise'> Frontend Developer</small>
    {/* <summary > I'm available for work...</summary> */}
 
    <a className='link' href="">Hire me</a>
    </div>
    </div>
    <h2 className="projects">My Projects</h2>
  <Caraousel/>
  
      </>
    )
  }



 
 